import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import './panel.css';
import frm from './formAux.js'
import tabler from './nlp/tabler_adl.js';
import './nlp/tabler.css';


var descriptor = {};
var origDescriptor = null;
var ssoGroups = [];

function findGroup( id ) {
	let [grp,origin,gid] = id.split(/[:\/]/);
	return ssoGroups.find( s => s.origin == origin && s.gid == gid );
}

function groupId( g ) {
	return 'group:' + g.origin + '/' + g.gid;
}

function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring( o ){ return typeof(o) == 'string';}
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig,'').toLowerCase() }
function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}


function paletteWheel( div, brightness )
{
	if( !brightness ) brightness = 1;
  	var steps = [[255,0,0],[0,255,0],[0,0,255],[255,0,0]];
    var colors = [];
    function interpolate(v)
    {
        v *= steps.length-1;
        var i = Math.floor(v);
        var r = v-i;
        var ir = 1-r;
        // console.log( 'v', v, 'i', i, 'r', r );
        return [steps[i][0]*ir+steps[i+1][0]*r,steps[i][1]*ir+steps[i+1][1]*r,steps[i][2]*ir+steps[i+1][2]*r];
    }
    for( var d = 0 ; d < div ; d++ )
    {
        var c = interpolate( d/div);
        var hc = '#' + c.map( v => Math.min(Math.floor(v*brightness),255).toString(16).padStart(2,'0')).join('');
        colors.push( hc );
    }
    return colors;
}

var lastFields = {};
function booleanList( hook, source, opts, callback )
{
	if( !source ) source = {};
	if( !opts ) opts = {};
	var initValues = opts.initValues || 5;
	var pcolors = paletteWheel( initValues );
	var colorIdx = 0;
	if( !opts.maxSubLabels ) opts.maxSubLabels = 3;
	hook.html('');
	var obj = $('<DIV>').addClass('option-list');
	hook.append( obj );

	var output = {};
	lastFields = {};
	function setNext( key, val )
	{
		if( lastFields[key] )
		{
			lastFields[key].prop('next', val );
			val.prop('prev',lastFields[key]);
		}
		lastFields[key] = val;
	}

	function fieldKeyDown( ev )
	{
		// console.log( 'keyCode', ev.keyCode, ev )
		if( ev.keyCode == 9 && ev.shiftKey )
		{
			this.blur();
			var nx = $(ev.target).prop('prev');
			if( nx ) nx.focus();
			ev.preventDefault();
		}
		else if( (ev.target.tagName == 'INPUT' && ev.keyCode == 13) || ev.keyCode == 9)
		{
			this.blur();
			var nx = $(ev.target).prop('next');
			if( nx ) nx.focus();
			ev.preventDefault();
		}
	}

	function change()
	{
		if( callback ) callback( output );
	}

	var nItems = 0;
	var ckwid = 0;
	for( var f in opts.items )
	{
		var it = opts.items[f];
		var opt = $('<DIV>').addClass('option-item');
		obj.append(opt);
		output[f] = defined(source[f]) ? source[f] : (it.default || false);
		// console.log( 'f', f, source[f], output[f], it.default )

		var cont = $('<SPAN>').addClass('option-boolean');
		var ofield = $('<INPUT type="checkbox">').text('color').prop('checked',output[f]).prop('label',f);
		var k = f;
		ofield.on('change', function(){ output[$(this).prop('label')] = $(this).prop('checked'); change(); } )
		ofield.on('keydown', fieldKeyDown );
        ofield.change();
		setNext(f,ofield);
		cont.append(ofield);
		opt.append(cont);
		var h = $('<DIV>').text(it.label || f).addClass('option-boolean-label').prop('ck',ofield);
		h.on( 'click', function(){ $(this).prop('ck').click(); })
		opt.append(h);
		if( !ckwid ) ckwid = cont.outerWidth();
		nItems++;
	}
	if( nItems > 1 || opts.forceHeader )
	{
		var hLabels = opts.header || ['', 'Attribute'];
		var opt = $('<DIV>').addClass('option-item').addClass('option-header-bar');
		obj.prepend(opt);
		var h = $('<DIV>').text(hLabels[0]).addClass('option-header').css({width:ckwid});
		opt.append(h);
		var h = $('<DIV>').text(hLabels[1]).addClass('option-header');
		opt.append(h);
	}
	if( nItems == 0 ) obj.hide();
	if( opts.callbackOnInit ) change();
}

function optionList( hook, source, opts, callback )
{
	if( !source ) source = {};
	if( !opts ) opts = {};
	var initValues = opts.initValues || 10;
	var pcolors = paletteWheel( initValues );
	var colorIdx = 0;
	if( !opts.maxSubLabels ) opts.maxSubLabels = 3;
	hook.html('');
	var obj = $('<DIV>').addClass('option-list');
    hook.show();
	hook.append( obj );
	var olist = [];

	var lastFields = {};
	var fieldNames = Object.keys(opts.fields);
	var fieldKey = fieldNames[0];
	var fieldDefault = opts.defaultField || fieldNames[1];

	function cmd( c, idx )
	{
		console.log( 'cmd', c, idx, olist[idx], opts );
		if( c == 'right' && olist[idx].level < opts.maxSubLabels && olist[idx-1].level >= olist[idx].level && olist[idx-1].key )
		{
			olist[idx].level++;
			draw();
			change();
		}
		if( c == 'left' && olist[idx].level > 0 )
		{
			olist[idx].level--;
			draw();
			change();
		}
		if( c == 'add' )
		{
			olist.splice( idx+1, 0, {key:'', value:{}, level:olist[idx].level})
			draw();
			change();
		}
		if( c == 'del' )
		{
			olist.splice( idx, 1 );
			draw();
			change();
		}
		if( c == 'up' && idx > 0 )
		{
			var tmp = olist[idx];
			olist.splice( idx, 1 );
			olist.splice( idx-1, 0, tmp );
			draw();
			change();
		}
		if( c == 'down' && idx < olist.length-1 )
		{
			var tmp = olist[idx];
			olist.splice( idx, 1 );
			olist.splice( idx+1, 0, tmp );
			draw();
			change();
		}
	}

	var lastName = null;
	var lastAlias = null;


	var optWidths = [];
	function addOpt( key, value, level, idx )
	{
		// console.log( 'addOpt', key, value, level )
		if( !level ) level = 0;
		if( isstring(value) ) value = {};

		var opt = $('<DIV>').addClass('option-item');
		obj.append(opt);
		function setField(f,v)
		{
			if( f == fieldKey ) olist[idx].key = v;
			else olist[idx].value[f] = v;
		}
		function getField(f)
		{
			return f == fieldKey ? key : value[f];
		}

		fieldNames.forEach( f => {
			var fld = opts.fields[f];
			if( fld.type == 'text' )
			{
				var ofield = $('<INPUT type="text">').addClass('option-text').prop('placeholder', fld.placeholder || fld.label);
				ofield.val(getField(f));
				if( fld.className ) ofield.addClass(fld.className);
				ofield.on('change', function(){ setField( f, ofield.val() ); change(); } )
				ofield.on('focus', function(ev){ $(this).select() })
				ofield.on('keydown', fieldKeyDown );
                ofield.change();
				setNext(f,ofield);
				opt.append(ofield);
				if( f == fieldKey && level )
				{
					var ml = level*20;
					ofield.css({marginLeft:ml,width:ofield.outerWidth()-ml});
				}
				if( idx == 0 ) optWidths.push( ofield.outerWidth() );
			}
			if( fld.type == 'list' )
			{
				var ofield = $('<TEXTAREA>').addClass('option-text').prop('placeholder', fld.placeholder || fld.label);
				ofield.val((getField(f) || []).join('\n'));
				if( fld.className ) ofield.addClass(fld.className);
				ofield.on('change', function(){ setField( f, ofield.val().split('\n') ); change(); } )
				ofield.on('focus', function(ev){ $(this).select() })
				ofield.on('keydown', fieldKeyDown );
                ofield.change();
				setNext(f,ofield);
				opt.append(ofield);
				if( f == fieldKey && level )
				{
					ml = level*20;
					ofield.css({marginLeft:ml,width:ofield.outerWidth()-ml});
				}
				if( idx == 0 ) optWidths.push( ofield.outerWidth() );
			}
			if( fld.type == 'color' )
			{
				var cont = $('<SPAN>').addClass('option-container');
				var clr = getField(f);
				if( !clr ) clr = pcolors[colorIdx++%pcolors.length];
				var ofield = $('<INPUT type="color">').text('color').val(clr);
				ofield.on('change', function(){ setField( f, ofield.val() ); change(); } )
                ofield.change();
				cont.append(ofield);
				opt.append(cont);
				if( idx == 0 ) optWidths.push( cont.outerWidth() );
			}
			if( fld.type == 'boolean' )
			{
				var cont = $('<SPAN>').addClass('option-container');
				var ofield = $('<INPUT type="checkbox">').text('color').prop('checked',bool(getField(f))).prop('label',f);
				ofield.on('change', function(){ setField( $(this).prop('label'), $(this).prop('checked') ); change(); } )
				ofield.on('keydown', fieldKeyDown );
                ofield.change();
				setNext(f,ofield);
				cont.append(ofield);
				opt.append(cont);
				console.log( 'bool', f, cont.outerWidth() )
				if( idx == 0 ) optWidths.push( cont.outerWidth() );
			}
		});


		function setNext( key, val )
		{
			if( lastFields[key] )
			{
				lastFields[key].prop('next', val );
				val.prop('prev',lastFields[key]);
			}
			lastFields[key] = val;
		}

		function fieldKeyDown( ev )
		{
			// console.log( 'keyCode', ev.keyCode, ev )
			if( ev.keyCode == 9 && ev.shiftKey )
			{
				this.blur();
				var nx = $(ev.target).prop('prev');
				if( nx ) nx.focus();
				ev.preventDefault();
			}
			else if( (ev.target.tagName == 'INPUT' && ev.keyCode == 13) || ev.keyCode == 9)
			{
				this.blur();
				var nx = $(ev.target).prop('next');
				if( nx ) nx.focus();
				ev.preventDefault();
			}
		}
        if( opts.hideButtons ) return;
		if( opts.subLabels )
		{
			opt.append($('<BUTTON>').addClass('grey').html('<i class="fa fa-angle-left"></i>').click(function(){cmd('left',idx)}));
			opt.append($('<BUTTON>').addClass('grey').html('<i class="fa fa-angle-right"></i>').click(function(){cmd('right',idx)}));
		}
		opt.append($('<BUTTON>').addClass('grey').html('<i class="fa fa-angle-up"></i>').click(function(){cmd('up',idx)}));
		opt.append($('<BUTTON>').addClass('grey').html('<i class="fa fa-angle-down"></i>').click(function(){cmd('down',idx)}));
		opt.append($('<BUTTON>').addClass('red').html('<i class="fa fa-close"></i>').click(function(){cmd('del',idx)}));
		opt.append($('<BUTTON>').addClass('green').html('<i class="fa fa-plus"></i>').click(function(){cmd('add',idx)}));
	}

	function addOpts( sobj, level )
	{
		if( !level ) level = 0;
		var idx = 0;
		if( !isobj(sobj) ) return;
		for( var k in sobj )
		{
			var val = sobj[k];
			if( !defined(val) ) val = null;
			if( isstring(val) )
			{
				var v = val;
				val = {};
				val[fieldDefault] = v;
			}
			olist.push( {key:k, value: val, level: level } );
			if( isobj( val ) && val.sublabels  ) addOpts( val.sublabels, level+1 )
		}
	}

	function change()
	{
		var out = {};
		var stack = [out];
		olist.forEach( (o,idx) => {
			if( !o.key || o.key.trim() == '' ) return;
			stack[o.level][o.key] = o.value;
			o.value.sublabels = {};
			stack[o.level+1] = o.value.sublabels;
		});
		function clean( o )
		{
			for( var k in o )
			{
				if( o[k].sublabels )
				{
					if( Object.keys(o[k].sublabels).length == 0 ) delete o[k].sublabels;
					else clean( o[k].sublabels );
				}
			}
		}
		clean( out );
		if( callback ) callback( out );
	}

	function draw()
	{
        console.log( 'descriptor', descriptor )
		checkEmpty();
		lastName = null;
		lastAlias = null;
		obj.html('');
		olist[0].level = 0;
		optWidths = [];
		olist.forEach( (o,idx) => {
			if( idx && o.level-olist[idx-1].level > 1 ) o.level = olist[idx-1].level+1;
			addOpt( o.key, o.value, o.level, idx )
		} );
		// console.log( 'optWidths', optWidths );
		// header

		var opt = $('<DIV>').addClass('option-item').addClass('option-header-bar');
		obj.prepend(opt);
		fieldNames.forEach( (f,idx) => {
			var fld = opts.fields[f];
			// console.log( 'field', f, fld, optWidths[idx] )
			var h = $('<DIV>').text(fld.label).addClass('option-header').css({width:optWidths[idx]});
			opt.append(h);
		});
	}

	addOpts( source );

	function checkEmpty()
	{
		if( !olist.length )
		{
			olist.push({key:'',value:{},level: 0})
		}
	}
	checkEmpty();

	draw();
	if( opts.callbackOnInit ) change();
	// console.log( 'olist', olist  )
}

function setDescriptor( bool )
{
	for( var k in bool )
	{
		descriptor[k] = bool[k];
	}
}

function arr2Obj( a, keyName )
{
	if( !a ) a = [];
	var out = {};
	a.forEach( it => {
		console.log( 'it', it, it[keyName] )
		out[it[keyName]] = clone(it);
		delete out[keyName];
	})
	return out;
}

function obj2Arr( o, keyName )
{
	if( !o ) o = {};
	var out = [];
	for( var k in o )
	{
		var it = clone(o[k]);
		it[keyName] = k;
		out.push(it);
	}
	return out;
}

function arr2Bool( a )
{
	if( !a ) a = [];
	var out = {};
	a.forEach( it => {out[it] = true;} );
	return out;
}

function bool2Arr( o )
{
	if( !o ) o = {};
	var out = [];
	for( var k in o )
	{
		if( o[k] ) out.push(k);
	}
	return out;
}

// transform a objet with key and obj values to a { key: value, key2: value2, key3: value3 } object
function obj2Vals( o, keyName )
{
	if( !o ) o = {};
	var out = {};
	for( var k in o )
	{
		out[k] = o[k][keyName];
	}
	return out;
}

// transform a { key: value, key2: value2, key3: value3 } to a { key:{keyName:value}, key2:{keyName:value2}} object
function vals2Obj( o, keyName )
{
	if( !o ) o = {};
	var out = {};
	for( var k in o )
	{
		out[k] = {};
		out[k][keyName] = o[k];
	}
	return out;
}

function exists( o )
{
	if( !o ) return false;
	if( !isobj(o) ) return false;
	return Object.keys(o).length > 0;
}

function setCkRadio()
{
	$('.clickinput').unbind('click').on('click', function(ev){
		var r = $(this).find('input')[0].click();
	});

}

var datasetId = null;
var dataset = null;

var roleLabels = {'d_viewer':'Dataset Viewer', 'd_super': 'Dataset Supervisor', 'd_super,api': 'Dataset Supervisor'}

function DatasetWorkers(prop) {
	var workers = [];
	var roleFilter = '';
	var workersChanged = false;

	function workerExists( email, role )
	{
		for( var i = 0 ; i < workers.length ; i++ )
		{
			console.log('workerExists', workers[i].email, email, workers[i].role, role)
			
			// if( workers[i].email == email && workers[i].role == role )
			if( workers[i].email == email  )
			{
				let currentRole;
				for (let [key, value] of Object.entries(roleLabels)) {
					if (key == workers[i].role) {
						currentRole = value;
						console.log('hi45', currentRole)
						break;
					}
				}
				frm.myAlert('Already added', `Worker already added as ${currentRole}`);
				
				return true;
			}
		}
		return false;
	}
	function displayWorkers( role )
	{
		workers.sort( function(a,b){
			if( a.email == b.email )
			{
				if( a.role == b.role ) return a.jobs < b.jobs ? 1 : -1;
				return a.role < b.role ? -1 : 1;
			}
			return a.email < b.email ? -1 : 1;
		});
		var tbody = $('#results').html('');
		workers.forEach( (w, idx) => {
			if( role && w.role != role ) return;
			var tr = $('<TR>').addClass('clickable').prop('email',w.email).on('click',userClick);
			['email','role','jobs'].forEach( k => {
				var v = w[k];
				if( k == 'role' ) v = roleLabels[v];
				tr.append( $('<td>').text(v).addClass('worker-cell'))
			});
			tr.append( $('<td>').html('<i class="fa fa-close"></i>').addClass('worker-cell').prop('worker',w).addClass('worker-del').on('click',delWorker))
			tbody.append(tr);
		});

		var gnames = {}
		var desc = {
			title: 'Dataset Collaborators',
			columns: {
				name: 'Name',
				email: 'Email',
				group: 'Group',
				roleLabel: 'Role',
				delete: '',
			},
			filter: true,
			search: true,
			sort: true,
			pageSize: 10,
			noFilter: null,
			noSearch: null,
			noSort: null,
			clickCol: 'delete',
			noFilter: 'delete',
			noSort: 'delete',
			// centerCol:'delete',
			format: tabler.formatString,
			formatCol: {
				email: function(v) { return v.match(/^group:/) ? '(SSO Group)' : v }
			},
			centerCol: true,
		}
		var tab = tabler.table($('#documentlist'), desc, 'workers' );
		workers.forEach( a => {
			a.roleLabel = roleLabels[a.role];
			a.delete = '<i class="fa fa-times-circle fa-lg worker-del"></i>';
			a.group = gnames[a.gid] || '';
			if( a.email.match(/^group:/) ) {
				if( !a.name ) a.name = a.email;
				gnames[a.gid] = a.name;
			}

			tab.addRow(a, function( col, row, el ){
				delWorker( row, el );
			})
		});
		tab.draw();


	}

	function delWorker( w, obj )
	{
		if( !obj )
		{
			obj = this;
			w = $(obj).prop('worker');
		}
		function del()
		{
			if( w.email.match(/^group:/)) {
				workers = workers.filter( k => k.origin != w.origin || k.gid != w.gid || k.role != w.role )
				saveWorkers();
			}
			else {
				for( var i = 0 ; i < workers.length ; i++ )
					if( workers[i].email == w.email && workers[i].role == w.role )
					{
						workers.splice( i, 1 );
						workersChanged = true;
						saveWorkers();
						break;
					}
				// $(obj).parent('tr').remove();
			}
		}
		console.log( 'delworker', w.email, w.role, w.jobs );
		if( w.email.match( /^group:/) ) 
			frm.myAlert( 'Delete Collaborator', 'Delete group <b>' + w.name + '</b> and all collaborators?', 'Yes', del, 'Cancel' );
		else if( w.jobs > 0 ) frm.myAlert( 'Delete Collaborator', 'Delete <b>' + w.email + '</b> as ' + roleLabels[w.role] + '?', 'Yes', del, 'Cancel' );
		else del();
	}


	function userClick()
	{

	}

	var saving = false;
	function saveWorkers()
	{
		if( saving ) return;
		saving = true;
		window.post( 'save_team', {datasetId:window.GlobalVars.currentDatasetId,workers:workers}, async function(res){
			if( !frm.resultCheck(res)) return;
			findWorkers();
			saving = false;
		});
	}

	function findWorkers()
	{
		var match = {datasetId:window.GlobalVars.currentDatasetId};
		window.post('find_team',{match:match}, function( res ){
			console.log( 'find_team', res );
			workers = res.data.records;
			displayWorkers( roleFilter );
		})
	}

	function loadWorkers()
	{
		if( workersChanged )
		{
			return frm.myAlert( 'Save Current Workers First', 'You made changes to your worker list that are not saved. Please save them before selecting new workers' );
		}
		var workerList = [];


		var workerRole = null;
		var selected = Object.keys((window.GlobalVars.userTableCtx && window.GlobalVars.userTableCtx.selected) || {});
		if( selected.length == 0 ) return selectUsers();
		frm.myAlert( 'Add Collaborators to Project', '<div id="workerlist" class="workerinput"></div>', 'Add Workers', null, 'Cancel', null );
		function ckEmail( v )
		{
			return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v);
		}
		function selectUsers(ev)
		{
			window.GlobalVars.userProjectSelect = 1;
			window.saveSession();
			window.goPage('users');
			ev.stopPropagation();
			ev.preventDefault();
		}
		function init()
		{
			var emails = $('<textarea id="inputworkers">').attr('placeholder','Enter workers\' Emails').hide();
			if( selected.length ) emails.text( selected.join(', ') );
			var selUsers = $('<div>').html( selected.length + ' users selected. <a href="#">Click to select more</a><p></p>').on('click',selectUsers);
			var err1 = $('<div>').addClass('load-worker-error');
			var roleAn = $('<span class="load-worker-role clickinput"><input class="lrole" type="radio" name="lrole" value="nlp_an"><span> Annotator</span></span>');
			var roleQc = $('<span class="load-worker-role clickinput"><input class="lrole" type="radio" name="lrole" value="nlp_qc"><span> QC</span></span>');
			var err2 = $('<div>').addClass('load-worker-error');
			$('#workerlist').text('').append(err1,emails,selUsers,err2,roleAn,roleQc);
			setCkRadio();
			// emails.val('john@gmail.com; mary@yahoo.com peter@outlook.com\n\njane@pobox.com');
			$('#modal-close').unbind('click').on('click', function(ev){
				ev.preventDefault();
				err1.text('');
				err2.text('');
				$('.lrole').each( (idx,o) => {
					if( $(o).prop('checked') ) workerRole = $(o).val();
				})
				workerList = [];
				// $('#inputworkers').text().split(/[ ,;\n\r]/).forEach(w => {
				// 	if( ckEmail(w) ) workerList.push(w);
				// })
				workerList = selected;
				if( !workerList.length )
				{
					// err1.text('Please input valid worker Emails');
					err1.text('Please select workers');
					ev.preventDefault();
					return false;
				}
				if( !workerRole )
				{
					// err2.text('Please select the role for the loaded workers');
					err2.text('Please select the role for the selected workers');
					ev.preventDefault();
					return false;
				}
				workerList.forEach( w => {
					if( !workerExists( w, workerRole ) ) workers.push({email:w,role: workerRole, jobs:'-'});
				})
				workersChanged = true;
				displayWorkers( roleFilter );
				console.log( 'insert', datasetId, workerList, workerRole, workers );
				$(this).unbind('click')
				$(this).click();
				return false;
			})
		}
		setTimeout( init, 1 );
	}

    function initProject()
    {
		$('#topbuttons').html('');
		// $('#topbuttons').append('<div class="top-buttons-radio"><span class="load-worker-role clickinput"><input class="rfilter" type="radio" name="lrole" value=""><span> All</span></span><span class="load-worker-role clickinput"><input class="rfilter" type="radio" name="lrole" value="nlp_an"><span> Annotator</span></span><span class="load-worker-role clickinput"><input class="rfilter" type="radio" name="lrole" value="nlp_qc"><span> QC</span></div>')
		setCkRadio();
		$('.top-buttons-radio').find('input').change( function(ev){
			roleFilter = $(this).val();
			displayWorkers( roleFilter );
		});
        datasetId = window.GlobalVars.currentDatasetId;
        dataset = window.GlobalVars.currentDataset;
		if( !datasetId ) return;
		// $('#pageTitle').text( 'PDF Project Workers - ' + window.GlobalVars.PDFProjectName );
		$('#loadworkers').on('click', loadWorkers );
		$('#import').on('click', saveWorkers );

		findWorkers();
		window.post('find_users', {}, async users => {
			console.log( 'USERS', users );

			ssoGroups = (await window.post('get_sso_groups', {})).data;
			console.log( 'ssoGroups', ssoGroups )

			var dUsr = null;
			var dRole = null;
			var workerEmail = '';
			var workerGroup = null;
			var workerRole = 'd_super';
	
			function add()
			{
				var emailReg = new RegExp(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/);
				var txt = workerEmail;
				var m = txt.match(emailReg);
				if( m )
				{
					m = m[0];
					if( !workerExists( m, workerRole ) )
					{
						workers.push({email:m,role: workerRole, jobs:'-'});
						console.log( 'workers', workers )
						workersChanged = true;
						// displayWorkers( roleFilter );
						saveWorkers()
						$('#addusr').val('');
					}
				}
				// ssoGroups
				else {
					if( workerGroup ) {
						if( !workers.find( w => w.gid == workerGroup.gid && w.origin == workerGroup.origin ) ) {
							console.log( 'workerGroup.name', workerGroup.name )
							workers.push({
								email:groupId(workerGroup), 
								name: workerGroup.name,
								role: workerRole, 
								jobs:'-',
								gid:workerGroup.gid,
								origin:workerGroup.origin, 
								ssoGroup: true,
							});
							workersChanged = true;
							saveWorkers();
						}
						else {
							frm.myAlert('Already added', `${workerGroup.name} already added`);
						}
						dusr.setValue('')
						// workerGroup = null;
					}
					else if(!m) return frm.myAlert('Invalid Email ID', "Please mention valid email id");
				}				
			}
			function search()
			{
				var txt = $('#addusr').val().trim();
				var res = [];
				var list = [];
				var reg = new RegExp(txt,'i');
				users.data.records.forEach( e => {
					var line = (e.name||'') + ' ('+e.email+')';
					if( !line.match(reg) ) return;
					res.push('<div class="add-result-user">'+line+'</div>');
					list.push( line );
				})
				for( let g of ssoGroups ) {
					list.push({ value: groupId(g), label: 'Group: ' + g.name })
				}

				$('.add-result').show();
				$('.add-result').html(res.join(''))
				$('.add-result').css({top:''})
				$('.add-result-user').on('click', function(){
					$('#addusr').val($(this).text()).blur();
					$('.add-result').css({top:-2000})
				})
				setTimeout(function () {
					frm.eventOutsideEnd();
					frm.eventOutside($('.add-result'), 'click', function () {
						console.log( 'CLOSE')
						$('.add-result').hide();
						$('.add-result').css({top:-2000})
						frm.eventOutsideEnd();
					})
				}, 500)
				return list;
			}
			// $('.add-user').html(`
			// 	<input type="text" class="form-control" placeholder="Type user Name or Email to add a new team worker" id="addusr">
			// 	<select id="addhole" class="mdb-select md-form">
			// 	<option value="d_super">Dataset Supervisor</option>
			// 	<option value="d_viewer">Dataset Viewer</option>
			// 	</select>
			// 	<button id="adduserbtn" class="btn btn-primary">Add Collaborator</button>
			// 	<div class="add-result">result</div>
			// 	`);
			// $('#addusr').on('blur', function(){ $('.add-result').hide();}).attr('name', Math.random() );
			// $('#addusr').on('focus', function(){ this.select(); search();})
			// $('#addusr').on('keyup', function(ev){
			// 	console.log( 'keyup', ev.keyCode)
			// 	var list = search();
			// 	if( ev.keyCode == 13 && list.length < 2 )
			// 	{
			// 		if( list.length == 1 ) $('#addusr').val(list[0])
			// 		$('.add-result').hide();
			// 		$('.add-result').css({top:-2000});
			// 		add();
			// 	}
			// })
			// $('#adduserbtn').on('click',add)
			$('.add-result').css({top:-2000})
			var iusr = users.data.records.map( u => {
				return {
					label: (u.name || '') + ' (' + u.email + ')',
					value: u.email,
				}
			})
			for( let g of ssoGroups ) {
				iusr.push({ value: groupId(g), label: 'Group: ' + g.name })
			}

			var dusr = frm.dropDown($('.add-user'), iusr, '', { width: 420, allowNew: true, placeholder: 'Name or Email' }, function (v) {
				workerEmail = v;
				// ssoGroups
				workerGroup = null;
				if( v.match( /^group:/) ) {
					let g = findGroup(v);
					if( !g ) return;
					workerGroup = g;
					drole.setValue( g.priv )
				}
				let btntxt = '<i class="fa fa-plus mr-2"></i>' + (workerGroup ? 'Add Group' : 'Add Collaborator');
				$('#adduserbtn').html( btntxt )				
			}).addClass('imgcls-dropdown-setup');
			var drole = frm.dropDown($('.add-user'), [
				{value:"d_super", label:'Dataset Supervisor'},
				{value:"d_viewer", label:'Dataset Viewer'},
			], workerRole, { width: 250, search:false }, function (v) {
				workerRole = v;
			}).addClass('imgcls-dropdown-setup');
			$('.add-user').append( $('<button id="adduserbtn" class="btn btn-primary"><i class="fa fa-plus mr-2"></i> Add Collaborator</button>'));	
			$('#adduserbtn').off('click').on('click', add )

			$('#addusrdrop').css({marginLeft:10})

		});

    }
    useEffect( function(a){
        initProject();
		if(window.GlobalVars.userProjectSelect == 2)
		{
			window.GlobalVars.userProjectSelect = 0;
			window.saveSession();
			setTimeout( loadWorkers, 100 );
		}
		$('.maincontent').append('<div class="wizzbtn">');
		// window.wizzardButtons( $('.wizzbtn') )
    });

    return (
        <div fluid="md p-0" className="maincontent">
        <div className="row">
        <Col ssm={9} className="mt-3">
		<div id="topbuttons"></div>
		<Table id="documentlist" bordered hover size="sm" className="table-grid mt-3">
		</Table>

        </Col>
        <div className="add-user"></div><Col sm={2} className="mt-3 import-column">
        </Col>

        </div>
        </div>

    )
//	<Button id="import" variant="primary" type="button" className="saveworkers"><img className="svg_logo" src="imgs/import_file.svg"/>Save Workers</Button>
//	<Button id="loadworkers" variant="primary" type="button" className=""><img className="svg_logo" src="imgs/loading.svg"/>Add Worker</Button>
}

export default DatasetWorkers
